/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clean_Frail_Earthworm_CutInputs */

const fr_clean_frail_earthworm_cut = /** @type {(inputs: Clean_Frail_Earthworm_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

/**

* @param {Clean_Frail_Earthworm_CutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const clean_frail_earthworm_cut = /** @type {((inputs?: Clean_Frail_Earthworm_CutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clean_Frail_Earthworm_CutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_clean_frail_earthworm_cut(inputs)
});